import classNames from 'classnames/bind';
import styles from './History.module.css';

import { useAppSelector } from '../../../../hooks/useRedux';
import { useSlice } from '../../../../hooks/useSlice';

import { Library } from '../../../../types/library';

import Item from '../Item';
import {
  DATE,
  NO_ACTIVITY_HISTORY,
  NUMBER_ABBR,
  PAGE,
  TIME,
} from '../../../../constants';
import { formatDate } from '../../../../utils/date';

interface History {
  id: string;
}

export default function History({ id }: History) {
  const cx = classNames.bind(styles);
  const { selectSelectedItem } = useSlice();
  const selectedItem = useAppSelector(selectSelectedItem);
  const historyList = selectedItem?.projectHistoryList;

  if (!historyList) return null;

  return (
    <Item id={id}>
      <div className={cx('panel_row')}>
        <div className={cx('table_list', 'table_head')}>
          <span>{NUMBER_ABBR}</span>
          <span>{DATE}</span>
          <span>{TIME}</span>
          <span>{PAGE}</span>
        </div>

        <div className={cx('table_list', 'table_body')}>
          {historyList.length ? (
            historyList.map(({ date, lastPage, seq, time }) => (
              <span key={seq} className={cx('items')}>
                <span>{seq}</span>
                <span>{formatDate(date)}</span>
                <span>{time}</span>
                <span>{`p.${lastPage}`}</span>
              </span>
            ))
          ) : (
            <div className={cx('desc')}>{NO_ACTIVITY_HISTORY}</div>
          )}
        </div>
      </div>
    </Item>
  );
}
